export class Enum {
  constructor(map) {
    let options = [];
    if (Array.isArray(map)) {
      this.map = {};
      map.forEach((item) => {
        this.map[item.id] = item.name;
        options.push({
          key: item.id,
          value: item.name,
        });
        if (item.code) {
          this[item.code] = item.id;
        }
      });
    } else {
      this.map = map;
      for (let key in map) {
        options.push({
          key: key,
          value: map[key],
        });
      }
    }
    this.options = options;
  }

  getOptions(hasAllOptions) {
    let options = [...this.options];
    if (hasAllOptions) {
      options.unshift({
        key: 0,
        value: '全部',
      });
    }
    return options;
  }

  getValue(key) {
    return this.map[key];
  }

  setItems(items) {
    // 只覆盖已有属性
    for (const key in this.map) {
      if (key in items) {
        this.map[key] = items[key];
      }
    }
  }
}

export const CourseType = new Enum({
  // 0: "班会",
  // 1: "计费约课",
  // 2: "大班课",
  // 3: "小班课",
  // 4: "公开课",
  // 5: "点播课",
  // 7: "面授课",
  // 8: "音频课",
  // 9: "系统课",
  // 10: "图文课",
  // 15: "小组课",
  // 22: "混合课",
  0: '全部课程',
  1: '普通课程',
  2: '班级课程',
  3: '公开课',
  4: '一对一',
  16: '线上双师课',
});
// 7.0 需求 直播类型课时 前端统一展示 直播
export const CoursePeriodsType = new Enum({
  0: '班会',
  1: '计费约课',
  2: '直播课', // 大班课 直播
  3: '直播课', // 小班课 直播
  4: '公开课', // 公开课 直播
  5: '点播课',
  7: '面授课',
  8: '点播课',
  // 9: "系统课",
  10: '图文课',
  15: '直播课', // 分组课
  16: '双师课',
  23: '互动课',
  // 22: "混合课",
  102: '小灶答疑',
});
export const TeachCoursePeriodsType = new Enum({
  0: '班会',
  1: '计费约课',
  2: '大班课', // 大班课
  3: '小班课', // 小班课
  4: '公开课', // 公开课
  5: '点播',
  7: '面授',
  8: '点播',
  // 9: "系统课",
  10: '图文',
  15: '分组课', // 分组课
  16: '双师课',
  // 22: "混合课",
});
export const PayStatus = new Enum({
  1: '待支付',
  2: '已支付',
  3: '退款申请中',
  4: '退款中',
  5: '已退款',
  6: '退款失败',
  11: '订单取消',
});

export const ShopStatus = new Enum({
  1: '待支付',
  2: '已支付',
  3: '退款申请中',
  4: '退款中',
  5: '已退款',
  6: '退款失败',
  7: '退款拒绝',
  8: '部分退款',
  9: '待发货',
  10: '已发货',
  11: '确认发货',
  12: '订单取消',
  13: '部分发货',
});

export const OrderStatus = new Enum({
  1: '待支付',
  2: '交易完成',
  3: '交易关闭',
});

export const ShopType = new Enum({
  1: '一对一',
  2: '大班课',
  3: '小班课',
  4: '公开课',
  5: '点播课',
  7: '面授课',
  8: '音频课',
  9: '系统课',
  10: '充值余额',
  11: '实物商品',
  12: '文库',
  20: '会员',
  21: '套卷',
  15: '小组课',
  16: '线上双师课',
});

export const PayType = new Enum({
  1: '微信',
  2: '支付宝',
  3: '虚拟币支付',
  4: '苹果支付',
  5: '学习卡兑换',
  6: '赠送',
  7: '优惠券支付',
  8: '线下支付',
  9: '积分兑换',
  10: '免费',
});

export const LiveStatus = new Enum({
  1: '未开始',
  2: '直播中',
  3: '已结束',
});

export const ExamTopicType = new Enum({
  1: '单选题',
  2: '判断题',
  3: '多选题',
  4: '不定项选择题',
  5: '简答题',
  6: '材料题',
  7: '填空题',
});

// 考试类型
export const ExamType = new Enum({
  1: '模拟考试',
  2: '正式考试',
});

// 作业状态
export const HomeworkStatus = new Enum({
  1: '未提交',
  2: '待批改',
  3: '已批改',
  4: '已过期',
  5: '已撤回',
});

// 作业报告状态
export const HomeworkReportStatus = new Enum({
  1: '已批改',
  2: '未提交',
});

// 作业发布状态
export const HomeworkPublishStatus = new Enum({
  1: '未发布',
  2: '已发布',
});

// 作业类型
export const HomeworkType = new Enum({
  1: '课程作业',
  2: '课时作业',
});

// 作业撤回状态
export const HomwworkWithdrawStatus = new Enum({
  1: '正常',
  2: '已撤回',
});

// 难易度
export const DifficultLevel = new Enum({
  1: '较难',
  2: '难',
  3: '中',
  4: '易',
  5: '较易',
});

// 试题类型
export const QuestionType = new Enum({
  1: '单选题',
  2: '判断题',
  3: '多选题',
  4: '不定项选择题',
  5: '简答题',
  6: '材料题',
  7: '填空题',
});

export const QuestionTypeOther = new Enum({
  1: '单选',
  2: '判断',
  3: '多选',
  4: '不定项',
  5: '简答',
  6: '材料',
});

// 考试管理退款状态
export const ExamRefundStatus = new Enum({
  2: '正常',
  5: '已退款',
});

export const ExamReviewStatus = new Enum({
  1: '已批阅',
  2: '待批阅',
});

export const ExamTermValidity = new Enum({
  1: '有效',
  2: '无效',
});
export const ExamFinishCondition = new Enum({
  1: '完成',
  2: '未完成',
});

export const ExamPassStatus = new Enum({
  1: '通过',
  2: '未通过',
});

// 发货状态
export const ShipStatus = new Enum({
  1: '待发货',
  2: '无需发货',
  3: '已发货',
  4: '已收货',
});

// 班级类型
export const ClassType = new Enum({
  1: '手动成班',
  2: '自动成班',
});

// 学习状态
export const StudyStatus = new Enum({
  1: '正常',
  2: '已过期',
});

export const PeriodsType = new Enum({
  1: '一对一',
  2: '一对多',
  3: '班课',
});

export const TeachingType = new Enum({
  1: '线上直播',
  2: '线下面授',
});

export const ArrangeStatus = new Enum({
  1: '未开始',
  2: '上课中',
  3: '已结束',
  4: '已取消',
});

// 班课状态
export const CurriculumDetailStatus = new Enum({
  1: '已开课',
  2: '未开课',
  3: '已结课',
  4: '未完成',
  5: '无效',
});

// 班课课次状态
export const CurriculumTimeStatus = new Enum({
  1: '已结束',
  2: '未开始',
  3: '上课中',
  4: '已取消',
});

// 考勤状态
export const AttendStatus = new Enum({
  0: '未上课',
  1: '出勤',
  2: '请假',
  3: '旷课',
});

// 考勤方式
export const AttendType = new Enum({
  0: '-',
  1: '人脸识别',
  2: '手动考勤',
  3: '缺勤',
  4: '请假',
  5: '直播间签到',
  6: '自动考勤',
  7: '课时票',
});

export const OrderRefundStatus = new Enum({
  1: '退款申请中',
  2: '退款成功',
  3: '已取消',
  4: '退款失败',
  5: '拒绝退款',
  6: '退款中',
});

// 公立校班级状态
export const ClassesStatus = new Enum({
  1: '上课中',
  2: '已结业',
});

// 公立校班级学员状态
export const ClassesStudentStatus = new Enum({
  1: '在班',
  2: '退班审核中',
  3: '退班',
});

// 公立校班级学员报名方式
export const ClassesJoinType = new Enum({
  1: '线上购买',
  2: '线下报名',
  3: '调班',
});

// 课程课时状态
export const CoursePeriodsStatus = new Enum({
  1: '未上课',
  2: '上课中',
  3: '已上课',
});

// 公立校班级学员到课情况
export const ClassesOpStatus = new Enum({
  0: '到课',
  1: '申请请假中',
  2: '请假',
  5: '旷课',
});

// 请假审批状态
export const ClassesApproveStatus = new Enum({
  1: '待审批',
  2: '已同意',
  3: '已驳回',
});

// 发帖用户类型
export const UserType = new Enum({
  1: '学生',
  2: '老师',
  3: '助教',
  4: '官方',
  5: '班主任',
});

// 课件类型
export const CoursewareType = new Enum({
  1: '普通文件',
  2: '动态文件',
  3: '音视频文件',
});

//会员等级
export const VipLevelType = new Enum({
  // 1: "天",
  2: '月',
  3: '季度',
  // 4: "半年",
  5: '年',
});
//发布状态
export const PublishStatus = new Enum({
  1: '未发布',
  2: '已发布',
  3: '已下架',
});
//考试状态
export const ExamStatus = new Enum({
  1: '未开始',
  2: '进行中',
  3: '已结束',
});
//试卷状态
export const TestStatus = new Enum({
  1: '已批阅',
  2: '待批阅',
  3: '已提交',
});
//通过状态
export const PassStatus = new Enum({
  1: '已通过',
  2: '未通过',
});
